import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { createActivity } from "../../services/api";

const ADMIN_KEY = "65473";

export default function CreateActivity() {
  const { register, handleSubmit, reset } = useForm();

  const onSubmit = async (data) => {
    if (data.key !== ADMIN_KEY) {
      toast.error("Only Admin can create activity..❌");
      return;
    }
  
    try {
      const payload = {
        name: data.name,
        slug: data.name.toLowerCase().trim().replace(/\s+/g, "-"),
        description: data.description,
      };
  
      await createActivity(payload);
  
      toast.success("Activity Created 🌿");
      reset();
    } catch (error) {
      console.error(error);
      toast.error("Error creating activity");
    }
  };

  return (
    <Box
        className="min-h-screen flex items-center justify-center px-4"
        // sx={{
        //   background:
        //     "linear-gradient(135deg, #ecfdf5, #d1fae5, #bbf7d0)",
        // }}
      >
        {/* 🌿 GLASS CARD */}
        <Paper
          elevation={0}
          sx={{
            width: "100%",
            maxWidth: "500px",
            p: 4,
            borderRadius: "24px",
  
            backdropFilter: "blur(20px)",
            background: "rgba(255,255,255,0.7)",
  
            boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          }}
        >
          <Typography
            variant="h5"
            mb={3}
            textAlign="center"
            sx={{ color: "#065f46", fontWeight: "bold" }}
          >
            🌿 Create Activity
          </Typography>
  
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col gap-5"
          >
            {/* 🌱 NAME */}
            <TextField
              label="Activity Name"
              fullWidth
              {...register("name", { required: true })}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "14px",
                },
              }}
            />
  
            {/* 📝 DESCRIPTION */}
            <TextField
              label="Description"
              multiline
              rows={3}
              fullWidth
              {...register("description")}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "14px",
                },
              }}
            />
  
            {/* 🔑 ADMIN KEY */}
            <TextField
              label="Admin Key"
              type="password"
              fullWidth
              {...register("key", { required: true })}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "14px",
                },
              }}
            />
  
            {/* 🚀 SUBMIT BUTTON */}
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                py: 1.5,
                borderRadius: "14px",
                fontWeight: "bold",
  
                background:
                  "linear-gradient(135deg, #22c55e, #16a34a)",
  
                boxShadow:
                  "0 10px 30px rgba(34,197,94,0.4)",
  
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #16a34a, #15803d)",
                },
              }}
            >
              🌿 Create Activity
            </Button>
          </form>
        </Paper>
      </Box>
  );
}


  
 



